<template>
  <div class="wrapper" ref="wrapper">
    <div>
      <div class="loaddingText" v-if="isLoadingTop">{{ topPullText }}</div>
      <slot></slot>
      <div class="loaddingTextBottom" v-if="isLoading">{{ bottomPullText }}</div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'

export default {
  name: 'scroll-box',
  props: {
    // 显示文字
    bottomPullText: {
      type: String,
      default: ''
    },
    topPullText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      wrapScroll: '', // 滚动容器对象
      isLoading: false,
      isLoadingTop: false,
      // 记录起始位置，防止上拉加载后回滚到顶；
      satrY: 0
    }
  },
  computed: {
    // 因为是将batter-scroll组件化， 所以我们需要抛出new出来的这个组件，  this.wrapScroll
    scroll () {
      return this.wrapScroll
    }
  },
  methods: {
    // 上拉加载
    uploadMore () {
      this.$emit('bottom-method')
      this.refresh()
    },
    downloadMore () {
      this.$emit('top-method')
      this.refresh()
    },
    // 加载完毕
    finishedUpload () {
      this.wrapScroll.finishPullUp()
    },
    // 刷新组件 （每次内容变化都要调用刷新，否则会出现无法滑动）
    refresh () {
      if (this.wrapScroll) {
        this.wrapScroll.refresh()
      }
    },
    scrollTo (el) {
      this.wrapScroll.scrollToElement(el, 300)
      this.$emit('bottom-method')
    }
  },
  mounted () {
    this.wrapScroll = new BScroll(this.$refs.wrapper, {
      // 是否允许上下滑动（是 true, 否 false）
      scrollY: true,
      // 是否允许左右滑动（是 true, 否 false）
      scrollX: false,
      // 上下滑动的起始点
      startY: this.satrY,
      probeType: 1,
      // 是否允许散发点击事件（是 true, 否 false）
      click: true,
      tap: true,
      pullUpLoad: true,
      mouseWheel: true,
      bindToWrapper: true,
      preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|DIV|SPAN|P|EM|I|IMG)$/ }
    })
    this.wrapScroll.on('scroll', pos => {
      if (this.wrapScroll.maxScrollY - pos.y > 50) {
        this.isLoading = true
      } else {
        this.isLoading = false
      }
      if (pos.y > 50) {
        this.isLoadingTop = true
      } else {
        this.isLoadingTop = false
      }
    })
    this.wrapScroll.on('touchEnd', pos => {
      // 上拉距离大于30   发布上拉加载事件
      if (this.wrapScroll.maxScrollY - pos.y > 50) {
        this.startY = this.wrapScroll.startY
        this.$emit('bottom-method')
        setTimeout(() => {
          this.refresh()
        }, 1000)
      }
      if (pos.y > 50) {
        this.startY = this.wrapScroll.startY
        this.$emit('top-method')
        setTimeout(() => {
          this.refresh()
        }, 1000)
      }
    })
  }
}
</script>

<style lang="less" scope>
.wrapper {
  overflow-y: auto;
  height: 100%;
  .loadmore-text-container {
    text-align: center;
    font-size: 16px;
    color: #ccc;
  }
  .loaddingText {
    font-size: 14px;
    position: absolute;
    width: 100%;
    top: -50px;
    text-align: center;
    line-height: 50px;
    // color: #ccc;
  }
  .loaddingTextBottom {
    font-size: 14px;
    position: absolute;
    width: 100%;
    bottom: -50px;
    text-align: center;
    line-height: 50px;
    // color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scroll.vue